import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button } from '~/components/ui/button'

function Denied() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className="flex h-dvh w-screen flex-col items-center justify-center gap-6 bg-white">
      <p className="text-lg font-bold text-primary">
        {t('access.denied.message')}
      </p>
      <Button
        variant="default"
        onClick={() => navigate('/')}
      >
        {t('common.back')}
      </Button>
    </div>
  )
}

export default Denied
